import { api } from './client';

export type MistakePeriod = '7d' | '30d' | '90d' | '180d';

export interface MistakeReport {
    success:         boolean;
    id?:             number;
    period?:         string;
    losses_count?:   number;
    matched_count?:  number;
    patterns:        string[];
    recommendations: string[];
    risk_issues:     string[];
    worst_symbols:   string[];
    ai_accuracy:     string;
    summary:         string;
    ai_provider?:    string;
    created_at?:     string;
    error?:          string;
}

export function fetchLastMistakeReport(period: MistakePeriod): Promise<MistakeReport> {
    return api.get<MistakeReport>(`/analyses/mistake-analysis/last?period=${period}`);
}

export function runMistakeAnalysis(period: MistakePeriod): Promise<MistakeReport> {
    return api.post<MistakeReport>(`/analyses/mistake-analysis?period=${period}`, {});
}
